<template>
  <div style="height:100%">
    <portal to="app-header">
      {{ $t('shiftSummary') }}
      <shift-selector v-if="currentDate && shiftList.length" />
      <v-tooltip bottom v-if="!isMobile">
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            small
            v-on="on"
            v-bind="attrs"
            class="ml-2"
            :disabled="loading"
            @click="getDashboardData"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        {{ $t('lastRefreshed') }} <strong>{{ lastRefreshedAt }}</strong>
      </v-tooltip>
    </portal>
    <v-row v-if="currentDate">
      <v-col cols="12" lg="12">
        <DowntimeByMachine />
      </v-col>
       <v-col cols="12" lg="12">
        <CycleTimeAnalysis />
      </v-col>
    </v-row>
  </div>
</template>
<!-- eslint-disable -->
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import ShiftSelector from './ShiftSelector.vue';
import DowntimeByMachine from './widgets/DowntimeByMachine.vue';
import CycleTimeAnalysis from './widgets/CycleTimeAnalysis.vue';

export default {
  name: 'ProductionDetails',
  components: {
    ShiftSelector,
    DowntimeByMachine,
    CycleTimeAnalysis
  },
  data() {
    return {
      fetching: false,
    };
  },
  async created() {
    this.fetching = true;
    await this.getBusinessTime();
    await Promise.all([
      this.getShifts(),
      // this.getMachines(),
      // this.fetchMachines(),
      // this.getOperators(),
    ]);
    this.fetching = false;
  },
  computed: {
    ...mapState('bottleneckMachineDashboard', [
      'currentDate',
      'lastRefreshedAt',
      'loading',
    ]),
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    ...mapGetters('bottleneckMachineDashboard', ['shiftList']),
  },
  methods: {
    ...mapActions('bottleneckMachineDashboard', [
      'getBusinessTime',
      'getShifts',
      // 'getMachines',
      // 'fetchMachines',
      // 'getOperators',
      // 'getRejectionReasons',
      // 'getDowntimeReasons',
      'getDashboardData',
    ]),
  },
};
</script>
